import type { PropsWithChildren } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';

export function FooterPaymentDetailsPlaceholder({ children }: PropsWithChildren): React.ReactNode {
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.FooterPaymentDetails);

  if (showPlaceholder) {
    return null;
  }

  return <>{children}</>;
}
